import React from "react";
import Review from "./Review";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Box, Flex, Heading, Stack } from "@chakra-ui/react";
import MainHeader from "./MainHeader";
import Footer from "./Footer";

const reviewList = [
  {
    name: "Camila J. V.",
    year: "2022",
    country: "co",
    type: "Accomodation",
    feedback:
      "I had the incredible privilege of staying at Victoria's home during my international research internship, and words can hardly capture the depth of my gratitude for the experience. From the moment I arrived, Victoria's warm hospitality and unwavering support enveloped me, making my journey far from home feel like a seamless transition. Victoria's home exudes an inviting charm that instantly put me at ease. The cozy ambiance, adorned with personal touches and a welcoming atmosphere, became a haven where I could concentrate on my research pursuits. It was a respite from the academic rigors, allowing me to delve into my work with renewed vigor. However, it wasn't just the physical environment that made this experience remarkable; it was Victoria herself. Her genuine interest in my research and her willingness to engage in meaningful conversations fostered an environment of intellectual growth and exchange. She shared invaluable insights, challenged my perspectives, and encouraged me to explore avenues I might not have considered otherwise. But beyond the academic realm, it was the camaraderie and companionship that truly set this experience apart. Victoria's kindness and willingness to share her life and experiences created a sense of belonging that transcended cultural boundaries. From exploring local attractions to sharing meals and stories, I felt like I was part of a new family that extended far beyond the confines of my research project. As a foreign intern, Victoria became my confidante and guide, helping me navigate the challenges of living in a foreign land. Her support during moments of doubt or homesickness was a beacon of light, reminding me that I was never alone in this journey. Her unwavering encouragement pushed me to overcome obstacles and strive for excellence in my work. Looking back, I can confidently say that my experience at Victoria's home has been a pivotal chapter in my academic and personal growth. The friendships formed, the knowledge gained, and the unwavering support I received have left an indelible mark on my heart. Victoria's role in shaping my international research internship cannot be overstated – she was not just a host, but a mentor, a friend, and a source of inspiration.",
  },
  {
    name: "Funmi O.",
    year: "2023",
    country: "ng",
    type: "Settling",
    feedback:
      "It was great having the support and guidance that Raven provides. I really enjoyed how Victoria took her time with all my sessions. She explained and prepared me mentally for this next phase of my life. I don’t feel as confused as I was prior to this.",
  },
  {
    name: "Fisayo O.",
    year: "2023",
    country: "ng",
    type: "Settling",
    feedback:
      "Moving from Nigeria to Canada as an international student was a huge step for me and Raven helped me prepare adequately. We discussed and sorted out navigation, maps, accommodation, fun activities in my new city, phone plan, monthly bills and so much more. I'm grateful that I got the guidance I needed from Raven.",
  },
];
const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 4000, min: 800 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

export const ReviewGroup = () => {
  return (
    <Box
      paddingLeft="24px"
      paddingRight="24px"
      paddingTop="8px"
      paddingBottom="8px"
      textAlign="center"
    >
      <Carousel arrows infinite responsive={responsive}>
        {reviewList.map((review, index) => (
          <Review key={index} {...review} />
        ))}
      </Carousel>
    </Box>
  );
};

export const Testimonials = () => {
  return (
    <Flex direction="column" minH="100vh">
      <MainHeader variant="info" />
      <Flex as="main" role="main" direction="column" flex="1" bg="#ebe8f1">
        <Stack
          bg="#ebe8f1"
          padding="32px"
          fontFamily="Garamond"
          fontSize="xl"
          marginTop="8px"
          alignItems="flex-start"
          spacing={3}
        >
          <Heading as="h1" size="xl">
            Testimonials
          </Heading>
          {reviewList.map((review, index) => (
            <Review key={index} {...review} full />
          ))}
        </Stack>
      </Flex>
      <Footer />
    </Flex>
  );
};
